module.exports = __webpack_public_path__ + "static/media/medalla-dorada.29a0359a.png";